/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
/* eslint object-curly-newline: ["error", { "multiline": true }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import lodash from 'lodash';
import axios from 'axios';
import qs from 'qs';

// initial state
const state = {
  courses: [],
  loaders: {
    courses: false,
  },
  initializers: {
    courses: false,
  },
};

// getters
const getters = {
  courses: (state) => state.courses,
  loaders: (state) => state.loaders,
  initializers: (state) => state.initializers,
};

// actions
const actions = {
  getCourses({ commit }) {
    commit('TOGGLE_LOADING', { key: 'courses', value: true });
    return axios.get(`${CONFIG.get('BASE_URL')}/api/courses/getCourses/`)
      .then(({ data }) => {
        commit('SET_PROPERTY', { key: 'courses', value: data });
        commit('TOGGLE_LOADING', { key: 'courses', value: false });
        commit('TOGGLE_INITIALIZED', { key: 'courses', value: true });
      });
  },
  setProperty({ commit }, payload) {
    commit('SET_PROPERTY', payload);
  },
};

// mutations
const mutations = {
  SET_PROPERTY(state, payload) {
    state[payload.key] = payload.value;
  },
  TOGGLE_LOADING(state, payload) {
    state.loaders[payload.key] = payload.value;
  },
  TOGGLE_INITIALIZED(state, payload) {
    state.initializers[payload.key] = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
